import md5 from "md5";
import { packsClient } from "lib/clients";
import getConfig from 'next/config';
import { sortAndFormat, flattenLayout } from "../utils";
import { decrypt } from "lib/e2ee";

const { publicRuntimeConfig: { genericSubDomain, baseProtocol, baseDomain, basePort } } = getConfig();

export const runSyncPack = async (
  pack: any, mutatePack: any, data: any, mutateAssets: any, currentUserId: string
) => {
  const assets = flattenLayout(data);

  const syncUpdates: any = {};
  let lastCreated = null;

  try {
    const updates = [];

    for (const asset of assets) {
      updates.push(asset.updated);
    }

    // deepcode ignore InsecureHash: this is not used for security reasons.
    const syncHash = md5(updates.join('|'));
    await packsClient.refreshPack(pack.id, syncHash, pack.updated);
  } catch (e) {
    if (e.response?.status === 401) {
      window.location.href = `${baseProtocol}://${genericSubDomain}${baseDomain}${basePort}/login`;
      return;
    }

    if (e.response?.status === 409) {
      const data = {
        updated: pack.updated,
        assets: []
      };

      for (const { id, updated } of assets) {
        data.assets.push({ id, updated });
      }

      const response = await packsClient.postSyncPack(pack.id, data);

      if (response.data.pack) {
        syncUpdates.pack = response.data.pack;
        delete syncUpdates.pack.key; // The decrypted key wont change, so no need to re-decrypt it.
      }

      const a = [...assets];

      for (const asset of response.data.update) {
        const idx = a.findIndex(ast => ast.id === asset.id);

        if (idx !== -1) {
          a[idx] = asset;
          
          if (asset.enc_data) {
            const data = await decrypt(asset.enc_data, pack.key);
            a[idx].data = data;
          }
        }
      }

      response.data.create.sort((x: any, y: any) => x.order - y.order);

      for (const asset of response.data.create) {
        if (asset.enc_data) {
          const data = await decrypt(asset.enc_data, pack.key);
          asset.data = data;
        }

        a.push(asset);
        lastCreated = asset;
      }

      // Need to sort, but deletes dont come with "order" so grab assets that we do have so we can sort.
      const deletes = [];

      for (const asset of response.data.delete) {
        const del = a.find(ast => ast.id === asset.id);

        if (del) {
          deletes.push(del);
        }
      }

      // Reverse the usual order
      deletes.sort((x, y) => y.order - x.order);

      for (const asset of deletes) {
        const idx = a.findIndex(ast => ast.id === asset.id);

        if (idx !== -1) {
          a.splice(idx, 1);
        }
      }

      a.sort((x, y) => x.order - y.order);
      syncUpdates.assets = a;
    }
  }

  if (syncUpdates.pack) {
    mutatePack((prev) => ({ ...prev, ...syncUpdates.pack }), false);
  }

  if (syncUpdates.assets) {
    mutateAssets(sortAndFormat(syncUpdates.assets), false);
  }

  // If an asset was created and it was created by the current user and added to the bottom of the list of assets, scroll to the bottom
  if (lastCreated && lastCreated.user_id === currentUserId) {
    const assets = syncUpdates.assets;

    if (assets[assets.length - 1].id !== lastCreated.id) {
      return;
    }

    const elements = document.querySelectorAll('#dnd-asset');
    const lastElement = elements[elements.length - 1];
    const position = lastElement.getBoundingClientRect();

    // checking whether fully visible
    if (position.top >= 0 && position.bottom <= window.innerHeight - 76) {
      return;
    }

    scroll({
      top: document.body.scrollHeight - window.innerHeight - 150,
      behavior: 'smooth'
    });
  }
}
